import LOGO from "../images/Aliados.png";

export const Team__Aliados = {
  name: "Aliados",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#FFFFFF",
  teamJerseyColor: "#31A0BC",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  // goalsScoredAgainst: 57 + 49 + 59,
  goalsScoredAgainst: 57 + 59,

  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      // goalsScored: 50 + 47 + 70,
      goalsScored: 50 + 70,

    },
  ],
};
